var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var ProjectManagerEvent;
(function (ProjectManagerEvent) {
    ProjectManagerEvent[ProjectManagerEvent["SaveStart"] = 0] = "SaveStart";
    ProjectManagerEvent[ProjectManagerEvent["SaveNoop"] = 1] = "SaveNoop";
    ProjectManagerEvent[ProjectManagerEvent["SaveSuccess"] = 2] = "SaveSuccess";
    ProjectManagerEvent[ProjectManagerEvent["SaveFail"] = 3] = "SaveFail";
})(ProjectManagerEvent || (ProjectManagerEvent = {}));
var ProjectManager = /** @class */ (function () {
    function ProjectManager(sourcesStore, channelsStore, channelId) {
        this.nextSaveTime = null;
        this.saveInterval = 30 * 1000; // 30 seconds
        this.saveInProgress = false;
        this.saveQueued = false;
        this.eventListeners = {};
        this.destroyed = false;
        this.channelId = channelId;
        this.sourcesStore = sourcesStore;
        this.channelsStore = channelsStore;
    }
    // Load the project from the sources and channels store.
    ProjectManager.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sourceResponse, source, channelResponse, channel, project, blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.destroyed) {
                            return [2 /*return*/, this.getNoopResponse()];
                        }
                        return [4 /*yield*/, this.sourcesStore.load(this.channelId)];
                    case 1:
                        sourceResponse = _a.sent();
                        source = {};
                        if (!sourceResponse.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, sourceResponse.json()];
                    case 2:
                        source = _a.sent();
                        this.lastSource = JSON.stringify(source);
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.channelsStore.load(this.channelId)];
                    case 4:
                        channelResponse = _a.sent();
                        if (!channelResponse.ok) {
                            return [2 /*return*/, channelResponse];
                        }
                        return [4 /*yield*/, channelResponse.json()];
                    case 5:
                        channel = _a.sent();
                        this.lastChannel = JSON.stringify(channel);
                        project = { source: source, channel: channel };
                        blob = new Blob([JSON.stringify(project)], {
                            type: 'application/json',
                        });
                        return [2 /*return*/, new Response(blob)];
                }
            });
        });
    };
    ProjectManager.prototype.hasUnsavedChanges = function () {
        return this.sourceChanged() || this.channelChanged();
    };
    // Shut down this project manager. All we do here is clear the existing
    // timeout, if it exists.
    ProjectManager.prototype.destroy = function () {
        this.resetSaveState();
        this.destroyed = true;
    };
    // TODO: Add functionality to reduce channel updates during
    // HoC "emergency mode" (see 1182-1187 in project.js).
    /**
     * Enqueue a save to happen in the next saveInterval, unless a force save is requested.
     * If a save is already enqueued, update this.projectToSave with the given project.
     * @param project Project: the project to save
     * @param forceSave boolean: if the save should happen immediately
     * @returns a promise that resolves to a Response. If the save is successful, the response
     * will be empty, otherwise it will contain failure information.
     */
    ProjectManager.prototype.save = function (project, forceSave) {
        if (forceSave === void 0) { forceSave = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.destroyed) {
                    // If we have already been destroyed, don't attempt to save.
                    this.resetSaveState();
                    return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                }
                this.projectToSave = project;
                if (!this.canSave(forceSave)) {
                    if (!this.saveQueued) {
                        this.enqueueSave();
                    }
                    return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                }
                else {
                    this.saveHelper();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Helper function to save a project, called either after a timeout or directly by save()
     * On a save, we check if there are unsaved changes. If there are none, we can skip the save.
     * If only the source has changed, we save both the source and channel, as we want to update the
     * lastUpdatedTime on the channel. If only the channel has changed, we skip saving the source and only
     * save the channel.
     * If we are saving both source and channel, only if the source save succeeds do we update the channel, as the
     * channel is metadata about the project and we don't want to save it unless the source
     * save succeeded.
     * @returns a Response. If the save is successful, the response will be empty,
     * otherwise it will contain failure or no-op information.
     */
    ProjectManager.prototype.saveHelper = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sourceChanged, channelChanged, sourceResponse, channelResponse, channelSaveResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.projectToSave) {
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        this.resetSaveState();
                        this.saveInProgress = true;
                        this.nextSaveTime = Date.now() + this.saveInterval;
                        this.executeListeners(ProjectManagerEvent.SaveStart);
                        sourceChanged = this.sourceChanged();
                        channelChanged = this.channelChanged();
                        // If neither source nor channel has actually changed, no need to save again.
                        if (!sourceChanged && !channelChanged) {
                            this.saveInProgress = false;
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        if (!sourceChanged) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sourcesStore.save(this.channelId, this.projectToSave.source)];
                    case 1:
                        sourceResponse = _a.sent();
                        if (!sourceResponse.ok) {
                            this.saveInProgress = false;
                            this.executeListeners(ProjectManagerEvent.SaveFail, sourceResponse);
                            // TODO: Should we wrap this response in some way?
                            // Maybe add a more specific statusText to the response?
                            return [2 /*return*/, sourceResponse];
                        }
                        this.lastSource = JSON.stringify(this.projectToSave.source);
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.channelsStore.save(this.projectToSave.channel)];
                    case 3:
                        channelResponse = _a.sent();
                        if (!channelResponse.ok) {
                            this.saveInProgress = false;
                            this.executeListeners(ProjectManagerEvent.SaveFail, channelResponse);
                            // TODO: Should we wrap this response in some way?
                            // Maybe add a more specific statusText to the response?
                            return [2 /*return*/, channelResponse];
                        }
                        this.lastChannel = JSON.stringify(this.projectToSave.channel);
                        return [4 /*yield*/, channelResponse.json()];
                    case 4:
                        channelSaveResponse = _a.sent();
                        this.saveInProgress = false;
                        this.lastSaveResponse = channelSaveResponse;
                        this.executeListeners(ProjectManagerEvent.SaveSuccess, this.lastSaveResponse);
                        return [2 /*return*/, new Response()];
                }
            });
        });
    };
    ProjectManager.prototype.canSave = function (forceSave) {
        if (this.saveInProgress) {
            return false;
        }
        else if (forceSave) {
            // If this is a force save, don't wait until the next save time.
            return true;
        }
        else if (this.nextSaveTime) {
            return this.nextSaveTime <= Date.now();
        }
        return true;
    };
    ProjectManager.prototype.enqueueSave = function () {
        var _this = this;
        this.saveQueued = true;
        this.currentTimeoutId = window.setTimeout(function () {
            _this.saveHelper();
        }, this.nextSaveTime ? this.nextSaveTime - Date.now() : this.saveInterval);
    };
    ProjectManager.prototype.addEventListener = function (type, listener) {
        var _a;
        if (this.eventListeners[type]) {
            (_a = this.eventListeners[type]) === null || _a === void 0 ? void 0 : _a.push(listener);
        }
        else {
            this.eventListeners[type] = [listener];
        }
    };
    ProjectManager.prototype.executeListeners = function (type, payload) {
        var _a;
        if (payload === void 0) { payload = {}; }
        (_a = this.eventListeners[type]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener(payload); });
    };
    ProjectManager.prototype.getNoopResponse = function () {
        return new Response(null, { status: 304 });
    };
    ProjectManager.prototype.getNoopResponseAndSendSaveNoopEvent = function () {
        var noopResponse = this.getNoopResponse();
        this.executeListeners(ProjectManagerEvent.SaveNoop, this.lastSaveResponse);
        return noopResponse;
    };
    ProjectManager.prototype.sourceChanged = function () {
        if (!this.projectToSave) {
            return false;
        }
        return this.lastSource !== JSON.stringify(this.projectToSave.source);
    };
    ProjectManager.prototype.channelChanged = function () {
        if (!this.projectToSave) {
            return false;
        }
        return this.lastChannel !== JSON.stringify(this.projectToSave.channel);
    };
    ProjectManager.prototype.resetSaveState = function () {
        if (this.currentTimeoutId !== undefined) {
            window.clearTimeout(this.currentTimeoutId);
            this.currentTimeoutId = undefined;
        }
        this.saveQueued = false;
    };
    return ProjectManager;
}());
export default ProjectManager;
